import React from "react";

const SMS = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1110_171426)">
        <path
          d="M26 6.97042V17.8089C26 19.4467 24.6732 20.7793 23.0421 20.7793H14.3783L7.92352 25.12V20.7793H6.9579C5.3268 20.7793 4 19.4467 4 17.8089V6.97042C4 5.33259 5.3268 4 6.9579 4H23.0421C24.6732 4 26 5.33259 26 6.97042Z"
          fill="white"
        />
      </g>
      <path
        d="M24.2414 8.07945V16.3834C24.2414 17.7491 23.1302 18.8603 21.7642 18.8603H13.6282L9.98235 21.2573V18.8603H8.29365C6.9276 18.8603 5.81641 17.7491 5.81641 16.3834V8.07945C5.81641 6.71373 6.9276 5.60254 8.29365 5.60254H21.7642C23.1302 5.60254 24.2414 6.71373 24.2414 8.07945Z"
        fill="url(#paint0_linear_1110_171426)"
      />
      <path
        d="M11.0664 10.0352H18.9881V11.3187H11.0664V10.0352Z"
        fill="#FFC93D"
      />
      <path
        d="M11.0664 13.1445H18.9881V14.428H11.0664V13.1445Z"
        fill="#FFC93D"
      />
      <path
        d="M15.0273 10.0352H18.9883V11.3187H15.0273V10.0352Z"
        fill="#FFBB0B"
      />
      <path
        d="M15.0273 13.1445H18.9883V14.428H15.0273V13.1445Z"
        fill="#FFBB0B"
      />
      <defs>
        <filter
          id="filter0_d_1110_171426"
          x="0"
          y="0"
          width="34"
          height="33.1201"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1110_171426"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1110_171426"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1110_171426"
          x1="7.97986"
          y1="6.62907"
          x2="17.5802"
          y2="18.1224"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F2F566" />
          <stop offset="1" stop-color="#F1DD27" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SMS;
